<script lang="ts">
    import ArrowIcon from "@apps/instagram/widgets/instagram_gallery_widget/components/icons/ArrowIcon.svelte";
    import { createEventDispatcher } from "svelte";

    import BaseButton from "@components/Buttons/BaseButton.svelte";
    import Icon from "@components/Icon.svelte";

    export let hasNext = false;
    export let hasPrev = false;
    const dispatch = createEventDispatcher();
    const handleNextSlide = (): void => {
        dispatch("nextSlide");
    };
    const handlePrevSlide = (): void => {
        dispatch("prevSlide");
    };
</script>

<div class="gw-slider-arrows">
    {#if hasPrev}
        <BaseButton
            ariaLabel="Previous instagram slide"
            class="gw-slider-arrows__arrow gw-slider-arrows__arrow--prev"
            on:click={handlePrevSlide}
        >
            <Icon width={14} height={14}>
                <ArrowIcon />
            </Icon>
        </BaseButton>
    {/if}
    {#if hasNext}
        <BaseButton
            ariaLabel="Next instagram slide"
            class="gw-slider-arrows__arrow gw-slider-arrows__arrow--next"
            on:click={handleNextSlide}
        >
            <Icon width={14} height={14}>
                <ArrowIcon />
            </Icon>
        </BaseButton>
    {/if}
</div>

<style lang="postcss" global>
    .gw-slider-arrows {
        & .gw-btn.gw-slider-arrows__arrow {
            display: flex;
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            color: #1d2939;

            &--prev {
                left: 10px;
                transform: translateY(-50%) rotateZ(180deg);
            }

            &--next {
                right: 10px;
            }

            &:hover {
                opacity: 1;
            }
        }

        @media screen and (max-width: 425px) {
            &__arrow {
                width: 25px;
                height: 25px;
                align-items: center;
            }
        }
    }
</style>
